import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { DASHBOARD_CUSTOMIZE_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const DashboardCustomizeRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={DASHBOARD_CUSTOMIZE_ROUNDED_GLYPH} />;
